/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.filters[_ngcontent-%COMP%]{display:inherit}select[_ngcontent-%COMP%]{margin:0 2px}.filter-label[_ngcontent-%COMP%]{margin:12px 6px 0 0;color:#3d516f;font-weight:700}"];
export { styles as styles };
